var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "500px",
      "overflow": "auto"
    }
  }, [_c('el-form', {
    ref: "from",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审批流名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入审批流名称"
    },
    model: {
      value: (_vm.from.name),
      callback: function($$v) {
        _vm.$set(_vm.from, "name", $$v)
      },
      expression: "from.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类型",
      "filterable": ""
    },
    model: {
      value: (_vm.from.type),
      callback: function($$v) {
        _vm.$set(_vm.from, "type", $$v)
      },
      expression: "from.type"
    }
  }, _vm._l((_vm.$parent.$parent.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "审批节点",
      "name": "first"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._l((_vm.objestSize), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "padding-left": "5px",
        "margin-top": "5px"
      },
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px #ebebeb solid",
        "height": "220px",
        "width": "315px"
      }
    }, [_c('el-form', {
      ref: "sysFlowDetailsfrom",
      refInFor: true,
      attrs: {
        "model": _vm.from.sysFlowDetails[index],
        "rules": _vm.sysFlowDetailsRules
      }
    }, [_c('el-row', {
      staticStyle: {
        "background-color": "#f3f3f3",
        "height": "40px"
      }
    }, [_c('el-form-item', [_c('span', {
      staticStyle: {
        "font-size": "15px",
        "margin-left": "10px",
        "line-height": "40px"
      }
    }, [_vm._v("节点" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "float": "right",
        "line-height": "30px",
        "margin-right": "10px"
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticClass: "el-icon-close",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.RemoveRecord(index)
        }
      }
    })])])], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "height": "80px",
        "line-height": "80px",
        "text-align": "center"
      }
    }, [_c('el-radio-group', {
      on: {
        "change": function($event) {
          return _vm.spjdchange(index)
        }
      },
      model: {
        value: (_vm.from.sysFlowDetails[index].is_leadership),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowDetails[index], "is_leadership", $$v)
        },
        expression: "from.sysFlowDetails[index].is_leadership"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("指定人\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("角色")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 3
      }
    }, [_vm._v("自选人\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "padding-bottom": "10px",
        "margin-top": "10px",
        "background-color": "#fdfdfd"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [(_vm.from.sysFlowDetails[index].is_leadership == 1) ? _c('el-form-item', {
      attrs: {
        "prop": "ids"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "filterable": "",
        "clearable": "",
        "multiple": "",
        "collapse-tags": "",
        "placeholder": "请选择指定人"
      },
      model: {
        value: (_vm.from.sysFlowDetails[index].ids),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowDetails[index], "ids", $$v)
        },
        expression: "from.sysFlowDetails[index].ids"
      }
    }, _vm._l((_vm.userList), function(user, userIndex) {
      return _c('el-option', {
        key: userIndex,
        attrs: {
          "label": user.staff_name,
          "value": user.staff_id
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.from.sysFlowDetails[index].is_leadership == 2) ? _c('el-form-item', {
      attrs: {
        "prop": "ids"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "clearable": "",
        "multiple": "",
        "collapse-tags": "",
        "placeholder": "请选择角色"
      },
      model: {
        value: (_vm.from.sysFlowDetails[index].ids),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowDetails[index], "ids", $$v)
        },
        expression: "from.sysFlowDetails[index].ids"
      }
    }, _vm._l((_vm.roleList), function(role) {
      return _c('el-option', {
        key: role.id,
        attrs: {
          "label": role.role_name,
          "value": role.id
        }
      })
    }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)])
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90px",
      "border": "1px #f8f8f8 solid",
      "margin-top": "5px",
      "margin-left": "5px",
      "text-align": "center",
      "background-color": "#fdfdfd"
    },
    on: {
      "click": _vm.AddRecord
    }
  }, [_c('img', {
    staticStyle: {
      "height": "220px",
      "width": "315px"
    },
    attrs: {
      "src": require("../../../../src/assets/审批+.png")
    }
  })])])], 2)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "审批条件",
      "name": "second"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._l((_vm.objestSize2), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "padding-left": "5px",
        "margin-top": "5px"
      },
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px #ebebeb solid",
        "height": "285px",
        "width": "315px"
      }
    }, [_c('el-form', {
      ref: "sysFlowCriteriasfrom2",
      refInFor: true,
      attrs: {
        "model": _vm.from.sysFlowCriterias[index],
        "rules": _vm.sysFlowCriteriasRules
      }
    }, [_c('el-row', {
      staticStyle: {
        "background-color": "#f3f3f3",
        "height": "40px"
      }
    }, [_c('el-form-item', [_c('span', {
      staticStyle: {
        "font-size": "15px",
        "margin-left": "10px",
        "line-height": "40px"
      }
    }, [_vm._v("审批条件" + _vm._s(index +
      1))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "float": "right",
        "line-height": "30px",
        "margin-right": "10px"
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticClass: "el-icon-close",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.RemoveRecord2(index)
        }
      }
    })])])], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "height": "40px",
        "line-height": "40px",
        "font-size": "15px",
        "margin-left": "30px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t审批条件\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "background-color": "#fdfdfd",
        "height": "40px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请选择条件"
      },
      on: {
        "change": function($event) {
          return _vm.sptjchange(index)
        }
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].approval_condition_type),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "approval_condition_type", $$v)
        },
        expression: "from.sysFlowCriterias[index].approval_condition_type"
      }
    }, _vm._l((_vm.approvalTypeList), function(approvalType) {
      return _c('el-option', {
        key: approvalType.value,
        attrs: {
          "label": approvalType.name,
          "value": approvalType.value
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "height": "40px",
        "line-height": "40px",
        "text-align": "center"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.from.sysFlowCriterias[index].approval_criteria),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "approval_criteria", $$v)
        },
        expression: "from.sysFlowCriterias[index].approval_criteria"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1 + ''
      }
    }, [_vm._v("大于")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2 + ''
      }
    }, [_vm._v("小于")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 3 + ''
      }
    }, [_vm._v("等于")])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "background-color": "#fdfdfd",
        "height": "40px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [(_vm.from.sysFlowCriterias[index].approval_condition_type == 1) ? _c('el-form-item', {
      attrs: {
        "prop": "ids"
      }
    }, [_c('el-cascader', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "clearable": "",
        "placeholder": "请选择架构",
        "collapse-tags": "",
        "show-all-levels": false,
        "props": _vm.props
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].ids),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "ids", $$v)
        },
        expression: "from.sysFlowCriterias[index].ids"
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "type": "textarea",
        "rows": 2,
        "disabled": ""
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].organizeName),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "organizeName", $$v)
        },
        expression: "from.sysFlowCriterias[index].organizeName"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.from.sysFlowCriterias[index].approval_condition_type == 2) ? _c('el-form-item', {
      attrs: {
        "prop": "ids"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "multiple": "",
        "collapse-tags": "",
        "placeholder": "请选择岗位",
        "clearable": ""
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].ids),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "ids", $$v)
        },
        expression: "from.sysFlowCriterias[index].ids"
      }
    }, _vm._l((_vm.postList), function(post) {
      return _c('el-option', {
        key: post.id,
        attrs: {
          "label": post.post_name,
          "value": post.id
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.from.sysFlowCriterias[index].approval_condition_type == 3) ? _c('el-form-item', {
      attrs: {
        "prop": "ids"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "multiple": "",
        "collapse-tags": "",
        "placeholder": "请选择保险类别",
        "clearable": ""
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].ids),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "ids", $$v)
        },
        expression: "from.sysFlowCriterias[index].ids"
      }
    }, _vm._l((_vm.insuranceTypeList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.data,
          "value": item.id
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.from.sysFlowCriterias[index].approval_condition_type == 4) ? _c('el-form-item', {
      attrs: {
        "prop": "judgment_conditions"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入薪资",
        "type": "number"
      },
      model: {
        value: (_vm.from.sysFlowCriterias[index].judgment_conditions),
        callback: function($$v) {
          _vm.$set(_vm.from.sysFlowCriterias[index], "judgment_conditions", $$v)
        },
        expression: "from.sysFlowCriterias[index].judgment_conditions"
      }
    })], 1) : _vm._e()], 1)], 1)], 1)], 1)])
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90px",
      "border": "1px #f8f8f8 solid",
      "margin-top": "5px",
      "margin-left": "5px",
      "text-align": "center",
      "background-color": "#fdfdfd"
    },
    on: {
      "click": _vm.AddRecord2
    }
  }, [_c('img', {
    staticStyle: {
      "height": "285px",
      "width": "315px"
    },
    attrs: {
      "src": require("../../../../src/assets/审批+.png")
    }
  })])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [(_vm.from.id === null || _vm.from.id === '') ? _c('el-button', {
    staticStyle: {
      "width": "20%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")]) : _c('el-button', {
    staticStyle: {
      "width": "20%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Modify
    }
  }, [_vm._v("修改")])], 1)], 1)])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa452de","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/flow/Flow_add.vue
// module id = null
// module chunks = 